// extracted by mini-css-extract-plugin
export var dropdown = "_ss-0";
export var imageWrapper = "_ss-3";
export var itemNameContainer = "_ss-1";
export var productImage = "_ss-2";
export var spinnerWrapper = "_ss-4";